import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { SonaOnboardingFacade } from '@sona/angular-onboarding';

/**
 * Marks the onboarding page as seen for the current user if not already marked.
 * Always allows activation.
 */
export const markOnboardingSeen: CanActivateFn = async () => {
    const facade = inject(SonaOnboardingFacade);

    if (!facade.hasSeenOnboardingPage()) {
        await facade.markOnboardingPageSeen();
    }

    return true;
};
